module.exports = __webpack_public_path__ + "static/media/cypress-io.34ea2932.png";